import noop from 'lodash/noop'
import { useContext, createContext } from 'react'

const Context = createContext({
  close: noop,
  addStep: noop,
  backStep: noop,
  addContractAddendums: noop,
  standardAddendums: [],
  setStandardAddendums: noop,
  standardSelected: [],
  setStandardSelected: noop,
  customAddendums: [],
  setCustomAddendums: noop,
  customSelected: [],
  setCustomSelected: noop,
  addendum: {},
  addendumType: null,
  titleText: null,
  footnote: null,
  buttonText: null,
  isEditing: false,
  onSubmit: noop,
  onSubmitComplete: null,
  onDelete: noop,
  onDeleteComplete: null,
  variables: {}
})

export default Context

export const useModal = () => {
  const context = useContext(Context)
  if (typeof context === 'undefined') {
    throw new Error('useModal must be used with a Provider')
  }
  return context
}
